import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2m-1.77-5.8a3 3 0 11-6 0 3 3 0 016 0z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2m-1.77-5.8a3 3 0 11-6 0 3 3 0 016 0z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "4",
    d: "M18 30L4.06 43.94M17 40.5h12.86c1.34 0 2.02-1.62 1.06-2.58l-8.3-8.3c-1.18-1.18-1.18-3.08 0-4.24l3.32-3.32c.94-.94.28-2.56-1.06-2.56H15L10.5 24m20.46-1.9l4.42 4.4a3.018 3.018 0 004.24 0l4.42-4.4M40.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z"
  }))
};
export var RunnerStroke = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});